import { render, staticRenderFns } from "./AprovadasSelo.vue?vue&type=template&id=149f843c&scoped=true"
import script from "./AprovadasSelo.vue?vue&type=script&lang=js"
export * from "./AprovadasSelo.vue?vue&type=script&lang=js"
import style0 from "./AprovadasSelo.vue?vue&type=style&index=0&id=149f843c&prod&lang=css"
import style1 from "./AprovadasSelo.vue?vue&type=style&index=1&id=149f843c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149f843c",
  null
  
)

export default component.exports